import { useNavigate, useParams } from 'react-router-dom';
import {
  FETCH_DONE_ASSESSMENT,
  FetchCohortWithLatestAssessmentsByDocumentIdQuery,
  FetchCohortWithLatestAssessmentsByDocumentIdQueryVariables,
} from '@edwin-group/cj-graphql';
import { useSuspenseQuery } from '@apollo/client';
import { useChapterStore } from '../../shared/store/useChapterStore';
import { useAssessmentStore } from '../store/useAssessmentStore';
import { useMissionStore } from '../../shared/store/useMissionStore';
import { useRoot } from './useRoot';
import { useEffect } from 'react';
// import { useAuthentication } from '@/hooks/useAuthentication';

export const useDoneAssessment = () => {
  useRoot();
  const mission = useMissionStore((state) => state.mission);
  const assessmentPage = useAssessmentStore((state) => state.assessmentPage);
  const status = useChapterStore((state) => state.status);
  // const { authentication } = useAuthentication();
  const navigate = useNavigate();

  const { cohortDocumentId } = useParams<{ cohortDocumentId: string }>();

  useEffect(() => {
    if (!mission?.missionStartedDocumentId) {
      navigate('/missions', { replace: true });
    }
  }, [mission?.missionStartedDocumentId, navigate]);

  const { data: assessmentData, error: errorAssessment } = useSuspenseQuery<
    FetchCohortWithLatestAssessmentsByDocumentIdQuery,
    FetchCohortWithLatestAssessmentsByDocumentIdQueryVariables
  >(FETCH_DONE_ASSESSMENT, {
    skip: !mission?.missionStartedDocumentId,
    variables: { documentId: cohortDocumentId!, missionStartedDocumentId: mission?.missionStartedDocumentId || '' },
    fetchPolicy: 'no-cache',
  });

  const hasReportingToolsAccess = true;

  const title = assessmentPage?.allDoneSection?.title;

  const description = assessmentPage?.allDoneSection?.description;

  const postAssessment = assessmentData?.fetchCohortWithLatestAssessmentsByDocumentId?.postAssessment;
  const preAssessment = assessmentData?.fetchCohortWithLatestAssessmentsByDocumentId?.preAssessment;

  return {
    status,
    mission,
    title,
    description,
    postAssessment,
    preAssessment,
    errorAssessment,
    hasReportingToolsAccess,
  };
};
